module.exports = __webpack_public_path__ + "img/制御工学5_8_5.5fef9eb1.png";